import favicon from 'assets/img/themes/riderclub/favicon.png';
import background from 'assets/img/themes/riderclub/background.jpg';
import logo from 'assets/img/themes/riderclub/logo.png';
import sidebarLogo from 'assets/img/themes/riderclub/logo-sidebar.png';
import collapsed from 'assets/img/themes/riderclub/logo-sidebar-collapsed.png';

export default {
  background: {
    src: background,
  },
  logo: {
    src: logo,
    height: '156px',
  },
  sidebar: {
    logo: sidebarLogo,
    collapsed: collapsed,
  },
  page: {
    title: 'RiderClub',
    favicon: favicon,
    support: 'RiderClub Support',
  },
  footer: {
    url: 'https://riderclub.com',
    copyright: 'RiderClub, LLC.',
    version: false,
    year: 2020,
  },
};
